
import { Vue, Component, Prop } from "vue-property-decorator";
import { TourManagerModel } from "../models/TourManagerModel";

@Component
export default class TourManager extends Vue {
  @Prop()
  tourManager: TourManagerModel;
}
